import { useContext, useEffect, useState } from 'react';

// Nucleus Components
import { useLazyDataModel } from '@thd-nucleus/data-sources';

import { DeliveryContext } from '../context/delivery-context';

export const useRentalConsumables = () => {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const [deliveryState, dispatch] = useContext(DeliveryContext);
  const { rentalCategory, rentalSubCategory } = deliveryState;

  const variables = {
    categoryCode: rentalCategory,
    subCategoryCode: rentalSubCategory,
  };

  const [getRentalConsumables] = useLazyDataModel('getRentalConsumables', {
    variables,
    ssr: false,
  });

  const executeRequest = async () => {
    setLoading(true);
    setError(null);

    try {
      const { data: rentalConsumablesData, error: rentalConsumablesError } = await getRentalConsumables({
        variables,
      });

      if (rentalConsumablesError) {
        throw new Error(rentalConsumablesError);
      }
      setData(rentalConsumablesData.getRentalConsumables.consumables);
    } catch (err) {
      setError(err.message || 'Unexpected Error');
      setData(null);
    } finally {
      setLoading(false);
    }

  };

  useEffect(() => {
    if (rentalCategory && rentalSubCategory) {
      executeRequest();
    }
  }, [rentalCategory, rentalSubCategory]);

  return { data, error, loading };
};
